import { createAction, createReducer } from '@reduxjs/toolkit';
import {
  IAction,
  IFared,
  IPartnerFared,
  IPeriodoUltimos12Meses,
} from './interfaces/apiInterfaces';
import {
  IInitialState,
  ILastTwelveMonths,
  IParnerPassedOn,
} from './interfaces/reduxInterfaces';

const INITIAL_STATE: IInitialState = {
  isActive: false,
  isLoading: false,
  gotSuccess: false,
  gotError: false,

  dateSearch: {
    start: '',
    end: '',
  },
  pixSent: {
    value: 0,
    quantity: 0,
  },
  pixReceived: {
    value: 0,
    quantity: 0,
  },
  fares: 0 || {
    fiducia: 0,
    global: 0,
    partner: 0,
  },
  faresReceived: {
    value: 0,
    quantity: 0,
  },
  faresPassedOn: {
    value: 0,
    quantity: 0,
  },
  income: {
    value: 0,
  },
  partnerPassedOn: [],
  lastTwelveMonths: [],
};

export const getPixFaresFromApi = createAction(
  '@faresApp/pixFares/GET_PIX_FARES_FROM_API'
);

export const gotPixFaresFromApi = createAction<any>(
  '@faresApp/pixFares/GOT_PIX_FARES_FROM_API'
);

export const gotErrorFromPixFaresApi = createAction(
  '@faresApp/pixFares/GOT_ERROR_FROM_PIX_FARES_API'
);

export const displayPixFares = createAction<boolean>(
  '@faresApp/pixFares/DISPLAY_PIX_FARES'
);

export const logoutPixFaresApp = createAction(
  '@faresApp/pixFares/LOGOUT_PIX_FARES_APP'
);

function isTypeNumberOrIFares(props: any) {
  const typeOfResponse = typeof props;
  let fares: IFared;
  let value: number;

  switch (typeOfResponse) {
    case 'object':
      fares = {
        fiducia: props.Fiducia,
        global: props.ambiente_382,
        partner: props.Parceiro,
      };
      return fares;

    case 'number':
      value = props;
      return value;

    default:
      return 0;
  }
}

const pixFaresReducer = createReducer(INITIAL_STATE, {
  [getPixFaresFromApi.type]: (state) => ({
    ...state,
    isActive: false,
    isLoading: true,
    gotSuccess: false,
    gotError: false,
  }),
  [gotPixFaresFromApi.type]: (state, action: IAction) => ({
    ...state,
    isActive: true,
    gotSuccess: true,
    gotError: false,
    isLoading: false,
    dateSearch: {
      start: action.payload.data_pesquisa.de,
      end: action.payload.data_pesquisa.ate,
    },
    pixSent: {
      value: action.payload.pix_enviadas.valor,
      quantity: action.payload.pix_enviadas.quantidade,
    },
    pixReceived: {
      value: action.payload.pix_recebidas.valor,
      quantity: action.payload.pix_recebidas.quantidade,
    },
    fares: isTypeNumberOrIFares(action.payload.tarifas),
    faresReceived: {
      value: action.payload.tarifas_cobradas.valor,
      quantity: action.payload.tarifas_cobradas.quantidade,
    },
    faresPassedOn: {
      value: action.payload.tarifas_repassadas.valor,
      quantity: action.payload.tarifas_repassadas.quantidade,
    },
    partnerPassedOn: action.payload.parceiros_repasse.map(
      (parceiro: IPartnerFared) => {
        const data: IParnerPassedOn = {
          partner: parceiro.parceiro,
          amountPassedOn: parceiro.quantidade_repasse,
          valuePassedOn: parceiro.valor_repasse,
          valueReceived: parceiro.valor_recebido,
          income: parceiro.receita,
        };
        return data;
      }
    ),
    lastTwelveMonths: action.payload.periodo_ultimos_12_meses.map(
      (mes: IPeriodoUltimos12Meses) => {
        const data: ILastTwelveMonths = {
          date: mes.data,
          faresReceived: {
            value: mes.tarifas_cobradas.valor,
            quantity: mes.tarifas_cobradas.quantidade,
          },
          faresPassedOn: {
            value: mes.tarifas_repassadas.valor,
            quantity: mes.tarifas_repassadas.quantidade,
          },
        };
        return data;
      }
    ),
    income: {
      value: action.payload.receita.valor,
    },
  }),
  [gotErrorFromPixFaresApi.type]: (state: IInitialState) => ({
    ...state,
    isActive: false,
    isLoading: false,
    gotSuccess: false,
    gotError: true,
  }),
  [displayPixFares.type]: (state: IInitialState, action) => ({
    ...state,
    isActive: action.payload,
  }),
  [logoutPixFaresApp.type]: (state: IInitialState) => ({
    ...state,
    isActive: false,
    isLoading: false,
    gotSuccess: false,
    gotError: false,
    dateSearch: {
      start: '',
      end: '',
    },
  }),
});

export default pixFaresReducer;
